//Style
import '../scss/style.scss';
import 'slick-carousel/slick/slick.scss';
import ScrollReveal from 'scrollreveal';

//Javascript
import jQuery from "jquery";
window.jQuery = jQuery;
import 'popper.js';
import 'bootstrap/js/dist/dropdown';
import slick from "slick-carousel";
import gsap from "gsap";


jQuery(document).ready(function ($) {


        ScrollReveal().reveal('.fieffect', {
            duration : 500,
            delay : 250,
            scale : .75
        });

});